import {DELIVERY_ADDRESS_STRUCTURE_FIELD_NAME, USER_ADDRESS_ID_FIELD_NAME} from 'modules/checkout/constants/fields';
import {useCheckoutFormikContext} from 'modules/checkout/hooks/useCheckoutFormikContext';
import {useIsLoggedIn} from 'modules/user/hooks/useIsLoggedIn';
import {DeliveryAddress} from 'new-models';
import {useCallback, useEffect} from 'react';

export const useCheckoutDeliveryAddress = (list: DeliveryAddress[]) => {
    const {setFieldValue, getFieldMeta} = useCheckoutFormikContext();

    const setValid = useCallback((address: DeliveryAddress) => {
        const {isDefault, isPrivateHouse} = address;
        return {
            ...Object.fromEntries(Object.entries(address).filter(([_, item]) => Boolean(item))),
            isDefault,
            isPrivateHouse,
        };
    }, []);

    const isLogged = useIsLoggedIn();
    useEffect(() => {
        const currentAddress = getFieldMeta(USER_ADDRESS_ID_FIELD_NAME).value;

        if (Boolean(currentAddress)) {
            return;
        }

        if (!isLogged) {
            setFieldValue(DELIVERY_ADDRESS_STRUCTURE_FIELD_NAME, setValid(list[0]));
            return;
        }

        setFieldValue(USER_ADDRESS_ID_FIELD_NAME, list[0].id);
    }, [getFieldMeta, isLogged, list, setFieldValue, setValid]);
};
